function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useQuery } from "@apollo/client";
import { useState } from "react";
import castAttributesFromModel from "../ModelDefinition/castAttributesFromDefinition";
import useSearchFilters from "./useSearchFilters";
function useTableList(name, options, searchOptions) {
  var query = options.query,
    _options$debug = options.debug,
    debug = _options$debug === void 0 ? false : _options$debug,
    _options$resetPaginat = options.resetPaginationOnComplete,
    resetPaginationOnComplete = _options$resetPaginat === void 0 ? true : _options$resetPaginat,
    _options$paginate = options.paginate,
    paginate = _options$paginate === void 0 ? true : _options$paginate,
    _onCompleted = options.onCompleted;
  var _ref = searchOptions || {},
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params;
  var _useState = useState(params || {}),
    _useState2 = _slicedToArray(_useState, 2),
    extraParams = _useState2[0],
    setExtraParams = _useState2[1];
  var _useSearchFilters = useSearchFilters((searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.key) || name, {
      debug: debug,
      enabled: !!searchOptions,
      defaultSearch: (searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.defaultSearch) || {},
      updateLocation: (searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.updateLocation) || false,
      history: searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.history,
      definition: searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.definition
    }),
    search = _useSearchFilters.search,
    onSearchChange = _useSearchFilters.onChange,
    onReset = _useSearchFilters.onReset;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    searchChanged = _useState4[0],
    setSearchChanged = _useState4[1];
  var _useState5 = useState({
      pageSize: 25,
      page: 1
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    internalPagination = _useState6[0],
    setInternalPagination = _useState6[1];
  var _useQuery = useQuery(query, {
      fetchPolicy: 'cache-and-network',
      variables: _objectSpread(_objectSpread({
        perPage: internalPagination.pageSize,
        page: internalPagination.page
      }, searchOptions ? {
        search: searchOptions.definition ? castAttributesFromModel(searchOptions.definition, _objectSpread(_objectSpread({}, search || {}), extraParams)) : _objectSpread(_objectSpread({}, search), extraParams)
      } : {}), options.variables || {}),
      onCompleted: function onCompleted(data) {
        setSearchChanged(false);
        if (resetPaginationOnComplete && searchChanged) setInternalPagination(_objectSpread(_objectSpread({}, internalPagination), {}, {
          page: 1
        }));
        if (_onCompleted) _onCompleted(data);
      }
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    refetch = _useQuery.refetch;
  var queryRoot = data ? data[name] || {} : {};
  var records;
  if (paginate) records = queryRoot[name] || [];else records = data ? data[name] : [];
  var pagination = paginate ? queryRoot.pagination || {} : {};
  var onPageChange = function onPageChange(page, pageSize) {
    setInternalPagination({
      page: page,
      pageSize: pageSize
    });
  };
  var paginationProps = pagination ? {
    current: pagination.page,
    pageSize: pagination.perPage || 25,
    total: pagination.total,
    showSizeChanger: false,
    onChange: onPageChange
  } : false;
  var handleSearchChange = function handleSearchChange(values) {
    setSearchChanged(true);
    if (onSearchChange) onSearchChange(values);
  };
  return {
    records: records,
    data: data,
    loading: loading,
    pagination: paginationProps,
    search: search,
    onSearchChange: handleSearchChange,
    setExtraParams: setExtraParams,
    refetch: refetch,
    onReset: onReset
  };
}
export default useTableList;